import { Order, OrderInvoice } from "@/api/SolarCloudApi";
import OrderCard from "@/components/OrderCard";
import PanelCard from "@/components/PanelCard";
import LoadingSpinner from "@/components/ui/LoadingSpinner";
import { useUsersOrders } from "@/queries/order/useUsersOrders";

type OrderInvoicePair = {
  order: Order;
  invoice: OrderInvoice;
}

export default function OrdersPanel() {
  const { data: orders, isLoading } = useUsersOrders();

  const orderInvoices: OrderInvoicePair[] = [];

  orders?.map(
    order => {
      order.invoices?.map(
        invoice => {
          orderInvoices.push({order, invoice});
        }
      )
    }
  );

  orderInvoices.sort(
    (oi1, oi2) =>
      oi2.invoice.paymentTimestamp!.localeCompare(oi1.invoice.paymentTimestamp!)
  );

  return (
    <>
      <PanelCard title="Transactions" className="">
        {isLoading && <LoadingSpinner className="mx-auto max-w-48" />}
        <div className="space-y-10">
          {
            orderInvoices.map(
              orderInvoice => (
                <OrderCard key={orderInvoice.invoice.uuid!} order={orderInvoice.order} invoice={orderInvoice.invoice} />
              )
            )
          }
          {orders && orders.length === 0 && (
            <p className="text-center text-lg text-white/80">
              You don't have any orders.
            </p>
          )}
        </div>
      </PanelCard>
    </>
  );
}
